let env = {};

env.baseURL = 'https://api.' + window.location.hostname + '/api/v1/'
env.normalURL = 'https://api.' + window.location.hostname + '/'

export default env



// WEBPACK FOOTER //
// ./src/config/env.js